import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { BgStandardStyled } from "./styled";

const BgStandard = ({
  theme_stadard_btn,
  theme_cancel,
  theme_standard_border,
  theme_bosendorfer,
  theme_red,
  theme_white_purple,
  theme_white_red,
  theme_none_border,
  type = "button",
  prefixLabel,
  label,
  onClick,
  disabled,
  bgColor,
  txtColor,
  height,
}) => {
  const customClass = cx({
    theme_stadard_btn: theme_stadard_btn,
    theme_cancel: theme_cancel,
    theme_standard_border: theme_standard_border,
    theme_bosendorfer: theme_bosendorfer,
    theme_red: theme_red,
    theme_white_purple: theme_white_purple,
    theme_white_red: theme_white_red,
    theme_none_border: theme_none_border,
  });
  return (
    <BgStandardStyled
      disabled={disabled}
      bgColor={bgColor}
      txtColor={txtColor}
      height={height}
    >
      <div className={customClass}>
        <button
          type={type}
          disabled={disabled}
          className="btn"
          onClick={onClick}
        >
          {prefixLabel && <span className="prefix_label">{prefixLabel}</span>}
          <span className="label_wrap">{label}</span>
        </button>
      </div>
    </BgStandardStyled>
  );
};

BgStandard.propTypes = {};

export default BgStandard;
